/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useForm } from 'react-hook-form';
import { Term } from 'useCases/service-terms';
import { useTranslate, useThemeOptions } from 'hooks';
import { setReadOnlyDefaultValue } from 'lib/contexts/input';
import { useAccreditationContext, useBusinessCardContext } from 'contexts';
import { Terms } from 'components/contexts/accreditation';
import {
  // Checkbox,
  Option,
  PasswordField,
  TextField,
  CustomSelect,
  HelperText,
} from 'components/form';
import {
  Button,
  // FormActions,
  FormGroup,
  Form,
  Heading,
  Paragraph,
  TrickSpace,
  ButtonSupport,
} from 'components/structure';
import SwitchToggleCheckbox from 'components/structure/SwitchToggle';
import { User } from 'interfaces/user';
import {
  ProjectNames,
  BRAZIL_COUNTRY_CODE,
  LINKEDIN_DEFAULT_URL,
} from 'constants/enums';
import { brazilianStates } from './BusinessCardForm.mock';
import * as S from './BusinessCardForm.styles';
import {
  schema,
  //schemaHasAdicionalFields,
  defaultValues as defaultValuesFromValidations,
} from './BusinessCardForm.validations';

type FormModel = {
  rePassword: string;
  terms: boolean;
  acceptedShareData: boolean;
  acceptedNews: boolean;
  numberOfPeopleWatchingWithMe?: number;
  ageGroup: number;
  ask1: string;
  ask3: string;
} & User;

export type BusinessCardFormProps = {
  onSubmit: (user: User) => void;
  isPending?: boolean;
  countries: Option[];
  profiles?: Option[];
  languages?: Option[];
  defaultValues?: User;
  showSupportButton?: boolean;
  hasLinkedInField?: boolean;
  hasMemberGetMember?: boolean;
  hasPasswordStrength?: boolean;
  hasCountry?: boolean;
  hasJobArea?: boolean;
};

const BusinessCardForm = ({
  onSubmit,
  isPending,
  defaultValues,
  showSupportButton,
  languages = [],
  countries,
  profiles = [],
  hasLinkedInField = false,
  // hasCountry = true,
  hasJobArea = false,
}: BusinessCardFormProps) => {
  const { themeName } = useThemeOptions();
  const translate = useTranslate();
  // const { data: { terms } = {} } = useTerms();
  const [showTerms, setShowTerms] = useState(false);
  const [term] = useState<Term>({} as Term);

  const linkedinInputRef = useRef<HTMLInputElement | null>(null);
  const { gettingStarted } = useAccreditationContext();
  const { setCardProps } = useBusinessCardContext();
  const {
    errors,
    register,
    handleSubmit,
    watch,
    // reset,
    control,
  } = useForm<FormModel>({
    resolver: yupResolver(schema),
    defaultValues: {
      ...defaultValuesFromValidations,
      ...defaultValues,
    },
  });
  const firstName = watch('firstName');
  const lastName = watch('lastName');
  const password = watch('password');
  const rePassword = watch('rePassword');
  const ask3 = watch('ask3');
  const ask2 = watch('ask2');
  const ask1 = watch('ask1');
  const email = watch('uuid');
  const profile = watch('profile');
  const linkedIn = watch('linkedInUrl');
  const country = watch('country', {
    label: 'Brasil',
    value: '76',
  });
  // const areaAsk2 = watch('ask2');
  const company = watch('company');
  useEffect(() => {
    setCardProps({
      name: firstName ? `${firstName} ${lastName}` : undefined,
      email,
      company,
      profile: profiles.find(({ value }) => value === profile?.area)?.label,
      linkedIn,
      country: {
        label: 'Brasil',
        value: '76',
      },
    });
  }, [
    firstName,
    lastName,
    email,
    country,
    linkedIn,
    profile?.area,
    countries,
    ask1,
    ask2,
    ask3,
    company,
    rePassword,
    password,
  ]);

  // useEffect(() => {
  // 	reset(defaultValues);
  // }, [defaultValues, reset]);

  useEffect(() => {
    if (linkedinInputRef.current && hasLinkedInField) {
      setReadOnlyDefaultValue(linkedinInputRef.current || LINKEDIN_DEFAULT_URL);
    }
  }, []);
  const onHandleSubmit = (user: User) => {
    // console.log(111, user.ask3, typeof user.ask3)
    onSubmit({
      ...user,
      ask3: user.ask3,
      ask4: user.ask4,
      password: user.password,
      rePassword: user.password,
      referrer: gettingStarted.referrer,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);
    // return onSubmit({ ...user, referrer: referrer ?? undefined });
  };

  // const handleSetIndexTerm = (currentTerm: string) => {
  //   if (!terms) return;

  //   setTerm(terms[currentTerm]);
  //   setShowTerms(true);
  // };
  const CountryField = () => (
    <CustomSelect
      control={control}
      name="country"
      label={translate('labels.country')}
      placeholder={translate('labels.country')}
      error={translate(errors?.country?.message)}
      options={countries}
    />
  );
  const themeNameParam = ProjectNames.VALE === themeName ? `.${themeName}` : '';
  // const LabelTerms = () => (
  //   <S.Term>
  //     {translate(
  //       `accreditation.businessCard.acceptTerms${themeNameParam}.accept`,
  //     )}
  //     <S.ButtonTerms
  //       onClick={() => {
  //         const currentTerm = 'useTerm';
  //         handleSetIndexTerm(currentTerm);
  //       }}
  //       type="button"
  //     >
  //       {translate(
  //         `accreditation.businessCard.acceptTerms${themeNameParam}.conditions`,
  //       )}
  //     </S.ButtonTerms>
  //     {translate(`accreditation.businessCard.acceptTerms${themeNameParam}.and`)}
  //     <S.ButtonTerms
  //       onClick={() => {
  //         const currentTerm = 'privacyTerm';
  //         handleSetIndexTerm(currentTerm);
  //       }}
  //       type="button"
  //     >
  //       {translate(
  //         `accreditation.businessCard.acceptTerms${themeNameParam}.policies`,
  //       )}
  //     </S.ButtonTerms>
  //     {/* {translate(
  //       `accreditation.businessCard.acceptTerms${themeNameParam}.policiesAnd`,
  //     )} */}
  //   </S.Term>
  // );
  return (
    <Form onSubmit={handleSubmit(onHandleSubmit)}>
      <Heading>{translate('accreditation.businessCard.title')}</Heading>
      <Paragraph>
        {translate('accreditation.businessCard.description')}
      </Paragraph>

      <FormGroup>
        <TextField
          name="email"
          ref={register}
          label={translate(`labels${themeNameParam}.email`)}
          placeholder={translate(`labels${themeNameParam}.email`)}
          error={!!errors?.email?.message}
          helperText={translate(errors?.email?.message)}
          // TODO check if uuid is email to enable edit
          readOnly
        />
      </FormGroup>

      <FormGroup>
        <TextField
          name="firstName"
          ref={register}
          label={translate('labels.name')}
          placeholder={translate('labels.name')}
          error={!!errors?.firstName?.message}
          helperText={translate(errors?.firstName?.message)}
        />
        <TextField
          name="lastName"
          ref={register}
          label={translate('labels.lastName')}
          placeholder={translate('labels.lastName')}
          error={!!errors?.lastName?.message}
          helperText={translate(errors?.lastName?.message)}
        />
      </FormGroup>

      {/* <FormGroup lgMargin>
        <TextField
          ref={register}
          label={'CRM (ex: RJ0000000)'}
          name="professionalId"
          placeholder='CRM (ex: RJ0000000)'
          error={!!errors?.professionalId?.message}
          helperText={errors?.professionalId?.message}
        />
        <TrickSpace />
      </FormGroup> */}

      {/* {areaAsk2 === '6' ? (
        <TextField
          name="ask4"
          ref={register}
          label={translate('labels.anotherArea')}
          placeholder={translate('labels.anotherArea')}
          error={!!errors?.ask4?.message}
          helperText={translate(errors?.ask4?.message)}
        />
      ) : (
        <TrickSpace />
      )} */}
      {/*<FormGroup lgMargin>
        {Number(country) === BRAZIL_COUNTRY_CODE ? (
          <>
            {CountryField()}
            <CustomSelect
              control={control}
              name="state"
              label={translate('labels.state')}
              placeholder={translate('labels.state')}
              error={errors?.state?.message}
              options={brazilianStates}
            />
          </>
        ) : (
          <>
            {CountryField()}
            <TrickSpace />
          </>
        )}
      </FormGroup>*/}
      {/*<FormGroup>
        <TextField
          name="ask1"
          ref={register}
          label={'Empresa'}
          placeholder={'Empresa'}
          error={!!errors?.ask1?.message}
          helperText={translate(errors?.ask1?.message)}
        />
        <TextField
          name="ask2"
          ref={register}
          label={'Cargo'}
          placeholder={'Cargo'}
          error={!!errors?.ask2?.message}
          helperText={translate(errors?.ask2?.message)}
        />
      </FormGroup>*/}
      {/*<FormGroup>
        <CustomSelect
          control={control}
          name="ask4"
          label={'Como soube do evento?'}
          placeholder={'Como soube do evento/ transmissão ao vivo?'}
          error={errors?.ask4?.message}
          options={[
            {
              label: 'Instagram',
              value: 'instagram',
            },
            {
              label: 'Facebook',
              value: 'facebook',
            },
            {
              label: 'LinkedIn',
              value: 'linkedin',
            },
            {
              label: 'Google',
              value: 'google',
            },
            {
              label: 'Parceiros',
              value: 'parceiros',
            },
            {
              label: 'Amigo',
              value: 'amigo',
            },
            {
              label: 'Outros',
              value: 'outros',
            },
          ]}
        />
      </FormGroup>*/}
      {/*<FormGroup>*/}
      {/* <TextField
          name="ask1"
          ref={register}
          label={'É associado AMPRO?'}
          placeholder={'Empresa'}
          error={!!errors?.firstName?.message}
          helperText={translate(errors?.ask1?.message)}
        /> */}
      {/*<CustomSelect
          control={control}
          name="ask3"
          label={'É associado AMPRO?'}
          placeholder={'É associado AMPRO?'}
          error={errors?.ask3?.message}
          options={[
            {
              label: 'Sim',
              value: 'true',
            },
            {
              label: 'Não',
              value: 'false',
            },
          ]}
        />
      </FormGroup>*/}
      <FormGroup hasMargin={false}>
        <S.PasswordContainer>
          <PasswordField
            name="password"
            autoComplete="new-password"
            ref={register}
            label={translate('labels.password')}
            placeholder={translate('labels.password')}
            error={!!errors?.password?.message}
            helperText={translate(errors?.password?.message)}
            minLength={6}
            maxLength={ProjectNames.VALE === themeName ? 6 : 100}
            showStrength
          />
          <S.Rules>
            {translate('accreditation.businessCard.rulesPassword')}
          </S.Rules>
        </S.PasswordContainer>
        <FormGroup lgMargin>
          <input ref={register} type="hidden" name="uuid" />
          <PasswordField
            name="rePassword"
            autoComplete="new-password"
            ref={register}
            label={translate('labels.passwordConfirmation')}
            placeholder={translate('labels.passwordConfirmation')}
            error={!!errors?.rePassword?.message}
            helperText={translate(errors?.rePassword?.message)}
            minLength={6}
            maxLength={ProjectNames.VALE === themeName ? 6 : 100}
          />
        </FormGroup>
      </FormGroup>

      <S.TermsContainer style={{ display: 'flex', columnGap: '.5rem' }}>
        <SwitchToggleCheckbox name={'terms'} register={register} />
        <p>
          Eu aceito os{' '}
          <S.LinkTerms
            target="_blank"
            href="https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Termos+de+Uso+AMPRO+2025.docx.pdf"
          >
            Termos e Condições de Uso
          </S.LinkTerms>{' '}
          e as{' '}
          <S.LinkTerms
            target="_blank"
            href="https://storage-files-tm1-eventos-prd.s3.us-east-2.amazonaws.com/ampro-2025/Poli%CC%81tica+Privacidade+AMPRO+2025.docx.pdf"
          >
            Políticas de Privacidade
          </S.LinkTerms>
          {/*.<HelperText error={true}>{errors.terms?.message}</HelperText>*/}
        </p>
      </S.TermsContainer>
      {showSupportButton && (
        <FormGroup lgMargin>
          <ButtonSupport
            onlyIcon={isMobile}
            fixedDesktop={!isMobile}
            icon={isMobile ? 'IcHelp' : undefined}
          />
        </FormGroup>
      )}
      {/* <FormActions> */}
      <S.ContainerButton>
        <Button
          fullWidth
          style={{
            marginBottom: '10px',
          }}
          type="submit"
          isLoading={isPending}
          disabled={isPending}
        >
          {translate('labels.next')}
        </Button>
      </S.ContainerButton>

      {/* </FormActions> */}
      <Terms
        term={term}
        show={showTerms}
        onConfirm={() => setShowTerms(false)}
      />
    </Form>
  );
};

export { BusinessCardForm };
